var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F37021"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.25 45C39.7778 45 36.3472 44.2433 32.9583 42.73C29.5694 41.2167 26.4861 39.0706 23.7083 36.2917C20.9306 33.5128 18.785 30.4294 17.2717 27.0417C15.7583 23.6539 15.0011 20.2233 15 16.75C15 16.25 15.1667 15.8333 15.5 15.5C15.8333 15.1667 16.25 15 16.75 15H23.5C23.8889 15 24.2361 15.1322 24.5417 15.3967C24.8472 15.6611 25.0278 15.9733 25.0833 16.3333L26.1667 22.1667C26.2222 22.6111 26.2083 22.9861 26.125 23.2917C26.0417 23.5972 25.8889 23.8611 25.6667 24.0833L21.625 28.1667C22.1806 29.1944 22.84 30.1872 23.6033 31.145C24.3667 32.1028 25.2072 33.0267 26.125 33.9167C26.9861 34.7778 27.8889 35.5767 28.8333 36.3133C29.7778 37.05 30.7778 37.7233 31.8333 38.3333L35.75 34.4167C36 34.1667 36.3267 33.9794 36.73 33.855C37.1333 33.7306 37.5289 33.6956 37.9167 33.75L43.6667 34.9167C44.0556 35.0278 44.375 35.2294 44.625 35.5217C44.875 35.8139 45 36.14 45 36.5V43.25C45 43.75 44.8333 44.1667 44.5 44.5C44.1667 44.8333 43.75 45 43.25 45Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.83043eca9165dc7776fe3864e0c1ef33.svg";
export { ForwardRef as ReactComponent };